import React, { useState } from 'react';
import { Ingredient } from '../types';
import { IngredientForm } from './IngredientForm';
import { AllergenBadge } from './AllergenBadge';
import { Plus, Pencil, Trash2, Package } from 'lucide-react';
interface IngredientListProps {
  ingredients: Ingredient[];
  onAdd: (ingredient: Omit<Ingredient, 'id' | 'createdAt'>) => void;
  onEdit: (id: string, ingredient: Omit<Ingredient, 'id' | 'createdAt'>) => void;
  onDelete: (id: string) => void;
}
export function IngredientList({
  ingredients,
  onAdd,
  onEdit,
  onDelete
}: IngredientListProps) {
  const [showForm, setShowForm] = useState(false);
  const [editingIngredient, setEditingIngredient] = useState<Ingredient | null>(null);
  const handleSave = (ingredient: Omit<Ingredient, 'id' | 'createdAt'>) => {
    if (editingIngredient) {
      onEdit(editingIngredient.id, ingredient);
    } else {
      onAdd(ingredient);
    }
    setShowForm(false);
    setEditingIngredient(null);
  };
  const handleEdit = (ingredient: Ingredient) => {
    setEditingIngredient(ingredient);
    setShowForm(true);
  };
  const handleCancel = () => {
    setShowForm(false);
    setEditingIngredient(null);
  };
  return <div data-id="element-152">
      <div className="flex items-center justify-between mb-6" data-id="element-153">
        <div data-id="element-154">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-155">Zutaten</h2>
          <p className="text-gray-600 mt-1" data-id="element-156">
            Verwalten Sie Ihre Zutaten mit automatischer Allergenerkennung
          </p>
        </div>
        <button onClick={() => setShowForm(true)} className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium" data-id="element-157">
          <Plus className="w-5 h-5" data-id="element-158" />
          Neue Zutat
        </button>
      </div>

      {ingredients.length === 0 ? <div className="text-center py-12 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300" data-id="element-159">
          <Package className="w-12 h-12 text-gray-400 mx-auto mb-3" data-id="element-160" />
          <h3 className="text-lg font-medium text-gray-900 mb-1" data-id="element-161">
            Keine Zutaten vorhanden
          </h3>
          <p className="text-gray-600 mb-4" data-id="element-162">Erstellen Sie Ihre erste Zutat</p>
          <button onClick={() => setShowForm(true)} className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium" data-id="element-163">
            <Plus className="w-5 h-5" data-id="element-164" />
            Zutat hinzufügen
          </button>
        </div> : <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-165">
          {ingredients.map(ingredient => <div key={ingredient.id} className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow" data-id="element-166">
              <div className="flex items-start justify-between mb-3" data-id="element-167">
                <h3 className="font-semibold text-gray-900 text-lg" data-id="element-168">
                  {ingredient.name}
                </h3>
                <div className="flex gap-1" data-id="element-169">
                  <button onClick={() => handleEdit(ingredient)} className="p-1.5 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors" data-id="element-170">
                    <Pencil className="w-4 h-4" data-id="element-171" />
                  </button>
                  <button onClick={() => {
              if (confirm(`Zutat "${ingredient.name}" wirklich löschen?`)) {
                onDelete(ingredient.id);
              }
            }} className="p-1.5 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded transition-colors" data-id="element-172">
                    <Trash2 className="w-4 h-4" data-id="element-173" />
                  </button>
                </div>
              </div>

              {ingredient.allergens.length > 0 ? <div className="flex flex-wrap gap-2" data-id="element-174">
                  {ingredient.allergens.map(allergenId => <AllergenBadge key={allergenId} allergenId={allergenId} size="sm" data-id="element-175" />)}
                </div> : <p className="text-sm text-gray-500" data-id="element-176">Keine Allergene</p>}
            </div>)}
        </div>}

      {showForm && <IngredientForm ingredient={editingIngredient || undefined} onSave={handleSave} onCancel={handleCancel} data-id="element-177" />}
    </div>;
}